import burger from "../assets/burger-icon.svg"
import {useEffect} from "react";

const OrganisationCard = (props) => {
    const organisation = props.organisation;

    // TODO: Uncomment to show preview of logo in circle
    // organisation.logo = "https://nerdl.io/assets/img/n-logo.png"

    return (
        <>
            <div className={organisation.hidden ? "organisation-card hidden link" : "organisation-card link"}
                 onClick={() => props.handleClick(organisation)} style={{border:  '1px solid #' + organisation.colour}}>
                <div className="organisation-card-title">
                    <div className="organisation-name">
                        {organisation && organisation.name}
                    </div>
                </div>
                <div className="organisation-card-description-container">
                    <div className="organisation-short-description">
                        {organisation && organisation.description}
                    </div>
                    <div className="organisation-logo">
                        <div className="organisation-card-logo-container" style={{backgroundColor: organisation.colour ? `#${organisation.colour}` : '#0082CA'}}>
                            {organisation && organisation.logo ?
                                <img src={organisation && organisation.logo} alt={organisation && organisation.name + " Logo"}
                                     className="organisation-card-logo" />
                                : null }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default OrganisationCard
